const SECTIONS = {
  HEALTH: 'health',
  PENSION: 'pension',
  WORKING_IN_SPACE: 'workingInSpace',
  FOOD: 'food',
  ALL_AROUND: 'allAround',
  IMPORTANT : 'important'
}

export default SECTIONS
